import React from "react";
import Navbar from "../components/layout/Navbar";
import { useNavigate } from "react-router-dom";
import handImg from "../assets/images/hand_surgery.png";
import { SERVICES_DATA } from "../data/services";
import "../styles/home.css";
import SeoHead from "../components/SeoHead";

const TESTIMONIALS = [
  { name: "Ramesh K.", loc: "Hyderabad", text: "After a severe crush injury at work, Dr. Suneel performed emergency reconstructive surgery. Within months I regained complete hand function. His skill is extraordinary.", stars: 5, initials: "RK", tag: "Hand Reconstruction" },
  { name: "Priya M.", loc: "Tirupati", text: "Years of wrist pain from carpal tunnel, and within days of Dr. Suneel's surgery I felt complete relief. Explained everything clearly. Highly recommended.", stars: 5, initials: "PM", tag: "Carpal Tunnel" },
  { name: "Venkat S.", loc: "Secunderabad", text: "Brachial plexus injury from a road accident. Dr. Suneel's microsurgical expertise restored almost complete arm movement. A life-changing outcome.", stars: 5, initials: "VS", tag: "Brachial Plexus" },
  { name: "Lakshmi R.", loc: "Hyderabad", text: "My child had a congenital hand deformity. Post surgery, the improvement is remarkable. Dr. Suneel's compassion and skill made all the difference.", stars: 5, initials: "LR", tag: "Congenital Deformity" },
];
// ─── HOME PAGE ───
export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      <SeoHead
        title="Hand & Wrist Clinics | Dr. R. Suneel — Hyderabad"
        description="Advanced Hand & Reconstructive microsurgery for sports injuries, fractures, nerve conditions, brachial plexus injuries and wrist disorders. Book a consultation with Dr. R. Suneel in Hyderabad."
        keywords="hand surgeon Hyderabad, wrist surgeon Hyderabad, carpal tunnel surgery Hyderabad, brachial plexus surgery, peripheral nerve surgery, hand surgery Medicover Hitech City, Dr Suneel hand surgeon"
        url="https://www.handandwristclinics.com/"
        image="https://www.handandwristclinics.com/static/media/hand_surgery.png"
      />
  
      {/* HERO */}
      <section className="hero hero-bg">
      <div className="hero-overlay"/>

      <div className="hero-orb-1"/>
      <div className="hero-orb-2"/>
      <div className="hero-grid"/>

      <div className="hero-content">
    
    {/* LEFT CONTENT ONLY */}
    <div>
      <div className="hero-eyebrow anim-1">
        <span/>
        India's Top Hand Surgery specialist Hyderabad's # 1 Hand Surgery Specialist

      </div>

      <h1 className="hero-h1 anim-2">
        Restore Strength.
        <em>Regain movements and control of your hands.</em>
      </h1>

      <p className="hero-tagline anim-3">
        Advanced Hand & Reconstructive microsurgery for sports injuries, fractures, nerve conditions, brachial plexus injuries and wrist disorders - delivered with precision and expertise
      </p>

      <div className="hero-ctas anim-4">
        <button className="btn-gold" onClick={() => navigate("/contact")}>
          Book Consultation Today
        </button>

        <a href="tel:+919393408108" className="hero-cta-phone">
          <span className="phone-ring"></span>
          Call Now: +91-9573152875
        </a>
      </div>

      <div className="hero-stats anim-5">
  {[
    { num: "15+", label: "Years Experience" },
    { num: "7500+", label: "Surgeries Done" },
    { num: "", label: "Speciality trained from top institutes" },
  ].map((s, i) => (
    <div className="hero-stat" key={i}>
      
      {s.num && <span className="stat-num">{s.num}</span>}

      <span className={`stat-label ${i === 2 ? "highlight-label" : ""}`}>
        {s.label}
      </span>

    </div>
  ))}
</div>
    </div>

  </div>
</section>

      {/* WHY CHOOSE US */}
      <section className="section section-white">
        <div className="container">
          <span className="section-tag">Why Choose Dr. Suneel</span>
          <h2 className="section-title">Expert Care You Can <em>Trust</em></h2>
          <div className="divider"/>
          <div className="why-grid">
            <div className="why-img-side">
              <div className="why-img"><img src={handImg} alt="Dr. Suneel Operating"/></div>
              <div className="why-float-badge">
                <div className="wfb-num">7500+</div>
                <div className="wfb-label">Successful Surgeries</div>
              </div>
              <div className="why-float-badge2">
                <div className="wfb2-icon"></div>
                <div className="wfb2-text">
                  <h5>CMC Vellore</h5>
                  <p>Fellowship Trained</p>
                </div>
              </div>
            </div>
            <div>
              <p className="section-sub" style={{marginBottom:"8px"}}>
                We combine deep subspecialty focus with advanced microsurgical techniques to deliver outcomes that restore your hand's full potential — not just adequate function.
              </p>
              <div className="why-features">
                {[
                  {  bg:"rgba(61,59,142,0.1)", title:"Subspecialty Expertise", keyword:"Dedicated focus", desc:"on hand, wrist, and nerve surgery — beyond general orthopedic practic." },
                  {  bg:"rgba(37,99,235,0.1)", title:"Advanced Microsurgery", keyword:"Fellowship-trained skills", desc:"for complex nerve and vessel repairs under magnification/microscope at centers of excellence." },
                  {  bg:"rgba(196,30,58,0.1)", title:"24/7 Emergency Care", keyword:"Round-the-clock availability", desc:"for traumatic hand and crush injuries requiring immediate intervention." },
                  {  bg:"rgba(5,150,105,0.1)", title:"Patient-First Approach", keyword:"Every treatment plan", desc:"is individualized, with clear communication and compassionate follow-through." },
                ].map((f, i) => (
                  <div className="why-feature" key={i}>
                    <div className="wf-icon" style={{background: f.bg}}>{f.icon}</div>
                    <div className="wf-text">
                      <h4>{f.title}</h4>
                      <p><span className="wf-keyword">{f.keyword}</span> {f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONDITIONS WE TREAT */}
      <section className="section section-indigo">
        <div className="container">
          <div style={{textAlign:"center",marginBottom:"8px"}}>
            <span className="section-tag" style={{background:"rgba(255,255,255,0.1)",color:"var(--gold-light)",borderColor:"rgba(201,168,76,0.25)"}}>Core Expertise</span>
          </div>
          <h2 className="section-title" style={{color:"white",textAlign:"center",marginTop:"12px"}}>Conditions We <em style={{color:"var(--gold-light)"}}>Treat</em></h2>
          <div className="conditions-grid">
            {[
              {  label:"Elbow Disorders", desc:"Fractures, dislocation, instability,stiff elbow "},
              {  label:"Wrist Arthroscopy",desc:"TFCC repair, ganglion excision, scaphoid nonunion, limited carpal fusions" },
              {  label:"Hand Injuries & Trauma", desc:"Fractures, dislocations, ligament injuries, sports injuries, crush injuries,industrial trauma,neglected injuries" },
              {  label:"Wrist Disorders", desc:"Wrist fractures, scaphoid fractures, carpal injuries and instabilities,  arthritis, deformities, Kienbocks" },
              {  label:"Nerve Injuries", desc:"Nerve injuries, Carpal tunnel and Cubital tunnel syndrome,  other compressive neuropathies, tumors, brachial plexus injuries" },
              {  label:"Tendon Repairs", desc:"Flexor/extensor tendon repairs, grafting, reconstruction, tendon transfers" },
              {  label:"Congenital Deformities", desc:"Syndactyly, polydactyly, radial club hand, absent thumb,  cleft hand, campto-clinodactyly, malformations" },
              {  label:"Microsurgery & Arthroscopy", desc:"Finger and hand replantation, vascular and nerve repair,  nerve tumors and nerve reconstruction" },
            ].map((c, i) => (
              <div className="condition-card" key={i}>
                <div className="cc-icon">{c.icon}</div>
                <div className="cc-label">{c.label}</div>
                <div className="cc-desc">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="section section-cream">
        <div className="container">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">Specialized Surgical <em>Centres</em></h2>
          <div className="divider"/>
          <p className="section-sub">We are unique and passionate in treating patients with ease.</p>
          <div className="services-grid">
            {SERVICES_DATA.map((s, i) => (
              <div className="service-card" key={i}>
                <div className="sc-img">
                  <img src={s.img} alt={s.title}/>
                  <div className="sc-img-overlay"/>
                  <div className="sc-icon-badge" style={{background:`${s.color}CC`}}>{s.icon}</div>
                  <div className="sc-subtitle">{s.subtitle}</div>
                </div>
                <div className="sc-body">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <div className="sc-tags">{s.conditions.slice(0,3).map((c,j) => <span className="sc-tag" key={j}>{c}</span>)}</div>
                  <button className="sc-cta" onClick={() => navigate(s.route)}>Explore Treatment →</button>
                </div>
              </div>
            ))}
          </div>
          <div style={{textAlign:"center",marginTop:"44px"}}>
            <button className="btn-indigo" onClick={() => navigate("/services")}>View All Services →</button>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS PREVIEW */}
      <section className="section section-white">
        <div className="container">
          <span className="section-tag">Patient Stories</span>
          <h2 className="section-title">Real Outcomes, <em>Real Trust</em></h2>
          <div className="divider"/>
          <div className="testi-grid">
            {TESTIMONIALS.slice(0, 2).map((t, i) => (
              <div className="testi-card" key={i}>
                <div className="testi-quote-mark">"</div>
                <div className="testi-top">
                  <div className="testi-avatar">{t.initials}</div>
                  <div style={{textAlign:"right"}}>
                    <div className="testi-stars">{"★".repeat(t.stars)}</div>
                    <div className="testi-tag" style={{marginTop:"6px"}}>{t.tag}</div>
                  </div>
                </div>
                <p className="testi-text">"{t.text}"</p>
                <div className="testi-author">
                  <h5>{t.name}</h5>
                  <span>{t.loc}</span>
                </div>
              </div>
            ))}
          </div>
          <div style={{textAlign:"center",marginTop:"32px"}}>
            <button className="btn-indigo" onClick={() => navigate("/testimonials")}>Read More Patient Stories →</button>
          </div>
        </div>
      </section>

      {/* APPOINTMENT STRIP */}
      <div className="appt-strip">
        <div className="container">
          <h2>Ready to Restore Your Hand Function?</h2>
          <p>Schedule a consultation with Dr. R. Suneel today. Available at Medicover Hospitals, Hitech City.</p>
          <div className="appt-strip-btns">
            <button className="btn-gold" onClick={() => navigate("/contact")}> Book Appointment</button>
            <a href="tel:+919393408108" className="btn-white-outline"> Call: +91 9573152875</a>
          </div>
        </div>
      </div>
    </>
  );
}




